import React from 'react';
import ItemCard from './ItemCard';
import { CopyIcon, TrashIcon } from '../icons';

const TextItem = ({
  content = '',
  date,
  device,
  onEdit,
  onDelete,
  onCopy,
  className = '',
  ...props
}) => {
  const actions = [
    onCopy && { key: 'copy', icon: CopyIcon, onClick: onCopy },
    onDelete && { key: 'delete', icon: TrashIcon, onClick: onDelete },
  ].filter(Boolean);

  return (
    <ItemCard
      date={date}
      device={device}
      actions={actions}
      onClick={onEdit}
      className={className}
      {...props}
    >
      <div className="p-2 h-full flex items-start">
        <div className="flex-1 min-w-0">
          <div className="text-xs font-medium text-[#121212] dark:text-[#D0D0D0] whitespace-pre overflow-hidden">
            {content}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-5 bg-gradient-to-t from-[#FFFFFF] dark:from-[#121212] to-transparent pointer-events-none" />
      <div className="absolute top-0 right-0 bottom-0 w-5 bg-gradient-to-l from-[#FFFFFF] dark:from-[#121212] to-transparent pointer-events-none" />
    </ItemCard>
  );
};

export default TextItem;
